
import './App.css';
import Finder from './components/finder';

function App() {
  return (
    <div>
      <Finder />
    </div>
  );
}

export default App;
